import { useStore } from "../lib/store";

export const iconButtonClass =
  "grid place-items-center size-11 rounded-lg text-ink hover:bg-surface-2 active:bg-surface-2 transition-colors";

export function ThemeToggle() {
  const theme = useStore((s) => s.theme);
  const setTheme = useStore((s) => s.setTheme);
  const dark = theme === "dark";
  const label = dark ? "Helles Design einschalten" : "Dunkles Design einschalten";
  return (
    <button type="button" className={iconButtonClass} aria-label={label} title={label} onClick={() => setTheme(dark ? "light" : "dark")}>
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {dark ? (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
          </>
        ) : (
          <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
        )}
      </svg>
    </button>
  );
}
